import {
    CLEAR_MARKETING_ADS,
    LOGOUT,
    SET_MARKETING_ADS_COMBINED,
    SET_MARKETING_ADS_FILTERS,
    SET_MARKETING_ADS_GOOGLE,
    SET_MARKETING_ADS_META,
} from '../actions/types';

const emptyChannel = () => ({
    cacheKey: '',
    campaigns: [],
    targets: {},
    daily: [],
    records: [],
    metaCampaigns: [],
    googleCampaigns: [],
    metaCityDaily: null,
    cityDailyCacheKey: '',
    combinedTargets: {},
    lastUpdated: null,
});

const initialState = {
    filters: {
        from: '',
        to: '',
        metaPlatform: 'both',
        channel: 'both',
    },
    meta: emptyChannel(),
    google: emptyChannel(),
    combined: emptyChannel(),
};

export default function marketingAdsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MARKETING_ADS_FILTERS:
            return {
                ...state,
                filters: { ...state.filters, ...action.payload },
            };
        case SET_MARKETING_ADS_META: {
            const cacheKey = action.payload.cacheKey || state.meta.cacheKey;
            const lastUpdated = action.payload.lastUpdated ?? Date.now();
            return {
                ...state,
                meta: { ...state.meta, ...action.payload, cacheKey, lastUpdated },
            };
        }
        case SET_MARKETING_ADS_GOOGLE: {
            const cacheKey = action.payload.cacheKey || state.google.cacheKey;
            const lastUpdated = action.payload.lastUpdated ?? Date.now();
            return {
                ...state,
                google: { ...state.google, ...action.payload, cacheKey, lastUpdated },
            };
        }
        case SET_MARKETING_ADS_COMBINED: {
            const cacheKey = action.payload.cacheKey || state.combined.cacheKey;
            const lastUpdated = action.payload.lastUpdated ?? Date.now();
            return {
                ...state,
                combined: { ...state.combined, ...action.payload, cacheKey, lastUpdated },
            };
        }
        case CLEAR_MARKETING_ADS:
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
}
